import { CustomAppLayout } from '../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useMemo, useState } from 'react';
import { useRouter } from '../../router';
//import { useStore } from '../store';
import { useGlobalState } from '../../../context/GlobalStateContext';


//import { useStoreAdmin } from '../../../context/useStoreAdmin';

import { ButtonDropdown, Cards, Popover, SegmentedControl, SpaceBetween, StatusIndicator, TextFilter } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import { addSeconds, parse } from 'date-fns';
import { useColor } from "react-color-palette";
import "react-color-palette/css"; // Don't forget the CSS!
import Copy from '../../../../components/Copy';
import Favorites from '../../../../components/extras/Favorites';
import { fetchWithWatch } from '../../../../hooks/fetchWithWatch';
import { ItemDisplay } from '../../../../resources/types';
import { addNotification, buildBreadcrumbItems, getCookie, getUrlVersion, setData, setLoading, setParameters } from '../../../commons/functions';


export const ConfigDisplaysPage = () => {
  //const storeAdmin = useStoreAdmin();
  const [displays, setDisplays] = useState<ItemDisplay[]>([]);
  const [display, setDisplay] = useState<ItemDisplay | null>(null);
  const [type, setType] = useState<string>("");

  const { navigate } = useRouter();
  const { menu, parameters, idAirport } = useGlobalState();
  const [localKeyword, setLocalKeyword] = useState(parameters?.displays?.keyword ?? "");
  const [color, setColor] = useColor("#1273de");

  useEffect(() => {
    setTimeout(() => {
      handleGetDisplays();
    }, 500);
  }, []);

  useEffect(() => {
    handleGetDisplays();
  }, [idAirport]);

  console.log(window.location.host)

  const handleIdentifyDisplay = async (idDisplay: number) => { // Make the function async

    try {
      setLoading(true)
      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'JWT': getCookie("JWT"),
          'x-routing': '/private/config/displays/identify',
        },
        body: JSON.stringify({ idDisplay: idDisplay }),

      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }
      const dataWeb = await response.json();
      if (dataWeb.code == 0) {

      } else {
        addNotification(dataWeb.status, 'error', setData);
      }
    } catch (error: any) {
      addNotification(`Error al contactar el servidor: ${error.message}`, 'error', setData);
    } finally {
      setLoading(false)
    }
  };
  const handleRefreshDisplay = async (idDisplay: number) => { // Make the function async

    try {
      setLoading(true)
      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'JWT': getCookie("JWT"),
          'x-routing': '/private/config/displays/refresh',
        },
        body: JSON.stringify({ idDisplay: idDisplay }),

      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }
      const dataWeb = await response.json();
      if (dataWeb.code == 0) {

      } else {
        addNotification(dataWeb.status, 'error', setData);
      }
    } catch (error: any) {
      addNotification(`Error al contactar el servidor: ${error.message}`, 'error', setData);
    } finally {
      setLoading(false)
    }
  };
  const handleGetDisplays = async () => { // Make the function async

    try {
      setLoading(true)
      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'JWT': getCookie("JWT"),
          'x-routing': '/private/config/displays/list',
        },
        body: JSON.stringify({ orderBy: "display", order: "ASC" }),

      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }
      const dataWeb = await response.json();
      if (dataWeb.code == 0) {
        setDisplays(dataWeb.displays);
      } else {
        addNotification(dataWeb.status, 'error', setData);
      }
    } catch (error: any) {
      addNotification(`Error al contactar el servidor: ${error.message}`, 'error', setData);
    } finally {
      setLoading(false)
    }
  };
  useEffect(() => {
    const timer = setTimeout(() => {
      // Only trigger global update if it actually changed
      if (localKeyword !== parameters?.displays?.keyword) {
        setParameters({
          ...parameters,
          displays: { ...parameters.displays, keyword: localKeyword }
        });
      }
    }, 400); // 400ms delay

    return () => clearTimeout(timer);
  }, [localKeyword]);

  useEffect(() => {
    setLocalKeyword(parameters?.displays?.keyword || "");
  }, [parameters?.displays?.keyword]);

  const filteredItems = useMemo(() => {
    // 1. If text is shorter than 2 chars, return everything
    const filteredByType = type ? displays.filter(item => item.jsonConfig?.type === type) : displays;

    if (localKeyword.length < 2) {
      return filteredByType;
    }

    const search = localKeyword.toLowerCase();
    // 2. Otherwise, filter by name OR id
    return filteredByType.filter(item =>
      item.display.toLowerCase().includes(search) ||
      item.idDisplay.toString().toLowerCase().includes(search)
    );
  }, [parameters?.displays?.keyword, displays, type]);
  const handleInputChange = (newValue: string) => {
    setLocalKeyword(newValue);
  };
  return (
    <CustomAppLayout
      toolsHide={true}
      breadcrumbs={
        <BreadcrumbGroup
          items={buildBreadcrumbItems(menu)}
          expandAriaLabel="Show path"
          ariaLabel="Breadcrumbs"
        />
      }
      content={
        <SpaceBetween size="s">
          <Header variant="h1" actions={<Favorites />}

          >{`Displays (${displays.length === filteredItems.length ? displays.length : `${filteredItems.length}/${displays.length}`})`}</Header>


          {displays && (
            <SpaceBetween size="s" direction='vertical'>
              <SpaceBetween size="s" direction='horizontal'>

                <TextFilter

                  filteringText={localKeyword}
                  filteringPlaceholder="Buscar displays..."
                  filteringAriaLabel="Filtrar displays"
                  onChange={({ detail }) => setLocalKeyword(detail.filteringText)}
                />
                <SegmentedControl selectedId={type} onChange={({ detail }) => setType(detail.selectedId)}
                  options={[
                    { id: '', text: 'Todos' },
                    { id: 'FIDS', text: 'FIDS' },
                    { id: 'BIDS', text: 'BIDS' },
                    { id: 'GIDS', text: 'GIDS' },
                    { id: 'COUNTER', text: 'CIDS' },
                    { id: 'JSON', text: 'JSON' },
                  ]}
                />
              </SpaceBetween>
              <Cards
                key="displays-cards"
                cardDefinition={{
                  header: item => (
                    <Header variant='h2'
                      actions={
                        <ButtonDropdown
                          variant="inline-icon"
                          onItemClick={(e) => {
                            if (e.detail.id === "refresh")
                              handleRefreshDisplay(item.idDisplay)
                            if (e.detail.id === "identify")
                              handleIdentifyDisplay(item.idDisplay)
                          }}
                          items={[
                            { id: "edit", text: "Editar", href: `#config/displays.edit?id=${item.idDisplay}` },
                            { id: "refresh", text: "Recargar" },
                            { id: "identify", text: "Identificar" },
                            { id: "view", text: "Visualizar", href: window.location.origin.includes("localhost") || window.location.origin.includes("[::1]") ? `http://localhost:3000/?id=${item.hashDisplay}` : `/v7/displays/?id=${item.hashDisplay}`, external: true },
                          ]}
                        />
                      }
                    >
                      <Popover header='Configuración' content={
                        <pre>{JSON.stringify(item.jsonConfig, null, 2)}</pre>
                      }>
                        {item.display === "" ? `sin nombre (${item.idDisplay})` : item.display}
                      </Popover>
                    </Header>
                  ),
                  sections: [
                    {
                      id: "idDisplay",
                      header: "ID",
                      content: item => <>{item.idDisplay}<Copy value={item.idDisplay.toString()} /></>,
                      width: 50
                    },
                    {
                      id: "isActive",
                      header: "Estado",
                      content: item => item.isActiveDisplay === 1 ? <StatusIndicator type="success">Activo</StatusIndicator> : <StatusIndicator type="error">Inactivo</StatusIndicator>,
                      width: 50
                    },
                    {
                      id: "cnx",
                      header: "Conectividad",
                      content: item => {
                        return (addSeconds(parse(item.lastCNX, "dd-MM-yyyy HH:mm:ss", new Date()), 30) > new Date()
                          ? <StatusIndicator type="success">{item.lastCNX}</StatusIndicator>
                          : <StatusIndicator type="error">{item.lastCNX}</StatusIndicator>
                        )
                      },
                      width: 100,
                    },

                    {
                      id: "type",
                      header: "Tipo",
                      content: item => item.jsonConfig?.type || "-----",
                      width: 50
                    },

                    {
                      id: "module",
                      header: "Módulo",
                      content: item => item.jsonConfig?.module || "-----",
                      width: 50
                    },
                  ]
                }}
                cardsPerRow={[
                  { cards: 1 },
                  { minWidth: 600, cards: 2 },
                  { minWidth: 900, cards: 3 },
                ]}
                items={(filteredItems || []) as ItemDisplay[]}
                trackBy="idDisplay"
              />
            </SpaceBetween>
          )}

        </SpaceBetween>
      }
    />
  )
};


{/* Disabled for now
                  <div style={{ padding: "20px", maxWidth: "300px" }}>
                    <h3>Select Theme Color</h3>

                    <ColorPicker
                      color={color}
                      onChange={setColor}
                      hideInput={["rgb", "hsv", "rgb"]} // Simplifies the UI for users
                    />

                    <div style={{ marginTop: "20px" }}>
                      <p>Selected Hex: <strong>{color.hex}</strong></p>
                      <div style={{
                        width: "100%",
                        height: "40px",
                        backgroundColor: color.hex,
                        borderRadius: "4px",
                        border: "1px solid #ccc"
                      }} />
                    </div>
                  </div>
                  {/* Disabled for now */}